import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

/**
 * Overrides Accept-Language on backend requests with the app's ACTIVE UI language (ILOPUMA-629).
 * Browsers/WebViews already send Accept-Language by default, but from the device/OS preferences —
 * which can be a language this app doesn't support. In that case ngx-translate falls back to its
 * own default while the device header still advertises the unsupported locale, so
 * backend-translated content (e.g. the attestation wallet's employment function names) would
 * disagree with the rest of the UI. Sending translateService.currentLang keeps both aligned.
 */
export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const translateService = inject(TranslateService);

  const currentLang = translateService.currentLang;
  if (req.url.includes(environment.backendUrl) && currentLang) {
    const newReq = req.clone({
      setHeaders: {
        'Accept-Language': currentLang,
      },
    });
    return next(newReq);
  }

  return next(req);
};
